import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const updateStudent = createAsyncThunk('updateStudent', async (data) => {

    try {
        const token = SessionManager.getCookie("user_token")
        const headers = { "Content-Type": "multipart/form-data" }
        if (token) {
            headers.Authorization = token
        }

        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + `update_student_details`,
            data: data?.values,
            headers
        })
        return res
    } catch (error) {
        return error.response
    }
})
